module.exports = __webpack_public_path__ + "img/65_12.5e023975.png";